// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render with activeStep 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-5 MuiStepper-alternativeLabel MuiPaper-elevation0"
      >
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel MuiStep-completed"
        >
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-completed"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
                />
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 1
              </span>
            </span>
          </span>
        </div>
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <div
            class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel MuiStepConnector-active"
          >
            <span
              class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-8 MuiStepConnector-lineHorizontal"
            />
          </div>
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  2
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 2
              </span>
            </span>
          </span>
        </div>
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <div
            class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
          >
            <span
              class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-8 MuiStepConnector-lineHorizontal"
            />
          </div>
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-7 MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  3
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 3
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-5 MuiStepper-alternativeLabel MuiPaper-elevation0"
    >
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel MuiStep-completed"
      >
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-completed"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
              />
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 1
            </span>
          </span>
        </span>
      </div>
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
      >
        <div
          class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel MuiStepConnector-active"
        >
          <span
            class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-8 MuiStepConnector-lineHorizontal"
          />
        </div>
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
              />
              <text
                class="MuiStepIcon-text"
                text-anchor="middle"
                x="12"
                y="16"
              >
                2
              </text>
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 2
            </span>
          </span>
        </span>
      </div>
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
      >
        <div
          class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
        >
          <span
            class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-8 MuiStepConnector-lineHorizontal"
          />
        </div>
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-7 MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
              />
              <text
                class="MuiStepIcon-text"
                text-anchor="middle"
                x="12"
                y="16"
              >
                3
              </text>
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-6 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 3
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;

exports[`render with default activeStep 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-1 MuiStepper-alternativeLabel MuiPaper-elevation0"
      >
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  1
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 1
              </span>
            </span>
          </span>
        </div>
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <div
            class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
          >
            <span
              class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
            />
          </div>
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  2
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 2
              </span>
            </span>
          </span>
        </div>
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <div
            class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
          >
            <span
              class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
            />
          </div>
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  3
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
              >
                step 3
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-1 MuiStepper-alternativeLabel MuiPaper-elevation0"
    >
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
      >
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
              />
              <text
                class="MuiStepIcon-text"
                text-anchor="middle"
                x="12"
                y="16"
              >
                1
              </text>
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 1
            </span>
          </span>
        </span>
      </div>
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
      >
        <div
          class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
        >
          <span
            class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
          />
        </div>
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
              />
              <text
                class="MuiStepIcon-text"
                text-anchor="middle"
                x="12"
                y="16"
              >
                2
              </text>
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 2
            </span>
          </span>
        </span>
      </div>
      <div
        class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
      >
        <div
          class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
        >
          <span
            class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
          />
        </div>
        <span
          class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
        >
          <span
            class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiStepIcon-root"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
              />
              <text
                class="MuiStepIcon-text"
                text-anchor="middle"
                x="12"
                y="16"
              >
                3
              </text>
            </svg>
          </span>
          <span
            class="MuiStepLabel-labelContainer"
          >
            <span
              class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
            >
              step 3
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
